import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IBase, IBaseSearchRequest, IGridResult } from 'src/app/core/models/base';
import { IOrder } from '../models/order';
import { OrderService } from '../services/order.service';

@UntilDestroy()
@Component({
    selector: 'app-order-grid-client',
    templateUrl: './order-grid-client.component.html',
    styleUrls: ['./order-grid-client.component.scss'],
    standalone: false
})
export class OrderGridClientComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private ordersService: OrderService
  ) { }

  public orders : IGridResult<IOrder[]>;

  ngOnInit(): void {
    this.orders = this.route.snapshot.data['orders'] as IGridResult<IOrder[]>;
  }

  reloadOrders(request: IBaseSearchRequest){
    this.ordersService.listorders(request)
    .pipe(untilDestroyed(this))
    .subscribe(response => {
      this.orders.data = response.data;
      this.orders.total = response.totalCount
    })
  }

  onReload(request: IBaseSearchRequest){
    this.reloadOrders(request);
  }

}
